// import { Button } from 'components'
import { IconWarningCircleRed } from 'components/Icons'
import { IProductSchema } from 'features/Ticket/model'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TicketProductTable } from 'types'
import { CreateTicketProductList } from '../CreateTicketProductList'

interface CreateTicketProductSectionProps {
  baseClass: string
  isLoading: boolean
  isError: boolean
  products: TicketProductTable[]
  setProducts: (products: TicketProductTable[]) => void
  setValue: (name: string, products?: IProductSchema[]) => void
}

export const CreateTicketProductSection: React.FC<CreateTicketProductSectionProps> =
  (props) => {
    const { baseClass, isLoading, isError, products, setProducts, setValue } =
      props

    const { t } = useTranslation(['common'])

    const [countProductSelected, setCountProductSelected] = useState<number>(0)
    const [isAllSelected, setIsAllSelected] = useState<boolean>(false)

    // * For support the API version stable limit 100 items
    // const onSelectAllProduct = () => {
    //   if (products.length > 0) {
    //     onSelectedProduct()
    //   }
    // }

    const onSelectedProduct = (index?: number) => {
      const tempProducts = [...products]

      if (index || index === 0) {
        const isSelected = !tempProducts[index].selected
        tempProducts[index].selected = isSelected
      } else {
        tempProducts.forEach((product) => {
          product.selected = !isAllSelected
        })
      }

      const selectedProducts = tempProducts
        .filter(({ selected }) => selected)
        .map(({ id, name }) => ({ productId: id, name: name }))

      const tempIsAllSelected = selectedProducts.length === tempProducts.length
      setIsAllSelected(tempIsAllSelected)

      setProducts(tempProducts)
      setValue(
        'products',
        selectedProducts.length ? selectedProducts : undefined,
      )

      const countSelected = tempProducts.filter(
        ({ selected }) => selected,
      ).length

      setCountProductSelected(countSelected)
    }

    const resetState = () => {
      setCountProductSelected(0)
      setIsAllSelected(false)
    }

    useEffect(() => {
      if (isLoading) {
        resetState()
      }

      return () => {
        resetState()
      }
    }, [isLoading])

    const countSelected = [
      t('common:countSelected.label'),
      countProductSelected,
      t('common:from.label'),
      products.length,
      t('common:row.label'),
    ].join(' ')

    // * For support the API version stable limit 100 items
    // const btnLabel = isAllSelected
    //   ? t('common:cancelSelectAll.label')
    //   : t('common:selectAll.label')

    return (
      <div className={`${baseClass}__wrap-product-table`}>
        <div className={`${baseClass}__wrap-header-table`}>
          <div className={`${baseClass}__wrap-header-btn`}>
            {/* // * For support the API version stable limit 100 items */}
            {/* <Button
              className={`${baseClass}__select-all-btn`}
              variants='outline'
              onClick={onSelectAllProduct}
            >
              {btnLabel}
            </Button> */}

            {Boolean(!countProductSelected && products.length) && (
              <span className='input-group__message-error'>
                <IconWarningCircleRed
                  variants='md'
                  className={`${baseClass}__icon-warn-product`}
                />
                {t('common:youStillNotSelectProduct')}
              </span>
            )}
          </div>

          <span>{countSelected}</span>
        </div>

        <CreateTicketProductList
          isLoading={isLoading}
          isError={isError}
          products={products}
          onSelectedProduct={onSelectedProduct}
          countProductSelected={countProductSelected}
        />
      </div>
    )
  }
